import React, { Component } from 'react';
import '../App.css';
import autosize from 'autosize';
/* global $ */

// old drafts will be lost on move to new site
// warning, loading user will replace post title and content
// TODO: and edit delete posts
// set all window location lookups to lower case
// save draft from 2 different category pages will lead to multiple drafts created
export default class MakePost extends Component {
  constructor(props){
    super(props);
    this.state = {
    };
  }
  
  dup_fixer(list, key) {    
    let key_counter = 0;
    let temp_key = key;
    while ( list.includes(temp_key) ){
      temp_key = key + key_counter;
      key_counter++;
    }
    key = temp_key;
    return key;
  }
  
  publish_or_draft(action) {
    let firebase = this.props.app_state.firebase;
    let title = $('#edit_title').val();
    let content = $('#edit_content').val();    
    let cat;
    if (window.location.pathname.split('/')[1].toLowerCase() === 'category') {
      cat = window.location.pathname.split('/')[2].toLowerCase();
    }
    else {
      cat = $('#user_choose_cat').val();      
    }
    
    let key = title.replace(/\W/g, '').toLowerCase();
    if (key.length === 0) {
      return $('#alert_danger').text('Post title is invalid').fadeIn().delay(1500).fadeOut();
    }
    if (content.replace(/\s/g, '').length === 0) {
      return $('#alert_danger').text('Post body is empty').fadeIn().delay(1500).fadeOut();
    }
    if (cat === '') {
      return $('#alert_danger').text('Please choose a category').fadeIn().delay(1500).fadeOut();
    }
    
    $('#alert_working').fadeIn().delay(1000).fadeOut();
    
    if (typeof this.this_draft === 'undefined' 
              || typeof this.this_draft.id === 'undefined'
              || !this.this_draft.id) {
      this.this_draft = {
        'id': key,
        'title': title,
        'content': content,
        'category': cat,
        'updated_time': Date.now(),
      };
    }
    else {
      this.this_draft['title'] = title;
      this.this_draft['content'] = content;
      this.this_draft['category'] = cat;
      this.this_draft['updated_time'] = Date.now();
    }
    
    let uid = this.props.app_state.this_user.id;
    let username = this.props.app_state.this_user.name;
    if (uid) {
      if (action === 'update_draft') {
        let draft_ref = firebase.database().ref('/main/users_sen/'+uid+'/post_drafts');
        draft_ref.child(this.this_draft.id)
          .update(this.this_draft)
          .then(() => {
            $('#alert_dark').text('Draft Saved').fadeIn().delay(1500).fadeOut();
          })
          .catch((error) => {
            $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
          });
      }
      else if(action === 'publish') {
        let pid = this.this_draft.id;
        this.this_draft['pub_time'] = Date.now();
        this.this_draft['num_comments'] = 0;
        
        
        let for_db = {};
        // clone because dicts are pass by reference
        for_db['posts/'+key] = $.extend(true, {}, this.this_draft);
        for_db['posts/'+key]['id'] = key;
        for_db['posts/'+key]['author'] = uid;
        for_db['posts/'+key]['author_name'] = username;
        
        for_db['users_sen/'+uid+'/post_drafts/'+pid] = null;
        
        for_db['users/'+uid+'/posts/'+key] = $.extend(true, {}, this.this_draft);
        for_db['users/'+uid+'/posts/'+key]['id'] = key;
        delete for_db['users/'+uid+'/posts/'+key]['content'];
        
        
        let posts_ref = firebase.database().ref('/main');
        // dup check, remember to delete draft
        posts_ref.child('posts/'+key).once('value')
          .then((snap) => {
            if (snap.val() === null) {
              // dup check passed
              
              posts_ref.update(for_db)
                .then(() => {
                  this.this_draft = undefined;
                  $('#edit_title').val('');
                  $('#edit_content').val('');
                  //$('#user_choose_cat').val('');
                  $('#alert_dark').text('Post Published').fadeIn().delay(2000).fadeOut();
                })
                .catch((error) => {
                  $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
                });
            }
            else {
              //dup check failed
              posts_ref.child('posts').once('value')
                .then((snap2) => {
                  // user dup fixer to generate new key from all post keys in db
                  let old_id = key;
                  let new_id = this.dup_fixer(Object.keys(snap2.val()), key);
                  
                  for_db['posts/'+new_id] = for_db['posts/'+old_id];
                  for_db['posts/'+new_id]['id'] = new_id;
                  delete for_db['posts/'+old_id];
                  
                  for_db['users/'+uid+'/posts/'+new_id] = for_db['users/'+uid+'/posts/'+old_id];
                  for_db['users/'+uid+'/posts/'+new_id]['id'] = new_id;
                  delete for_db['users/'+uid+'/posts/'+old_id];
                  
                  posts_ref.update(for_db)
                    .then(() => {
                      this.this_draft = undefined;
                      $('#edit_content').val('');
                      $('#edit_title').val('');
                      //$('#user_choose_cat').val('');
                      $('#alert_dark').text('Post Published').fadeIn().delay(2000).fadeOut();
                    })
                    .catch((error) => {
                      $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
                    });
                });
            }
          });
      }
    }
  }
  
  do_delete() {
    let firebase = this.props.app_state.firebase;
    $('#edit_title').val('');
    $('#edit_content').val('');
    //$('#user_choose_cat').val('');
    
    if (typeof this.this_draft === 'undefined' 
              || typeof this.this_draft.id === 'undefined'
              || !this.this_draft.id) {
      return;
    }
    
    let uid = this.props.app_state.this_user.id;
    if (uid) {
      let pid = this.this_draft.id;
      let for_db = {};
      for_db[pid] = null;      
      //console.log(for_db);
      firebase.database().ref('/main/users_sen/'+uid+'/post_drafts')
        .update(for_db)
        .then(() => {
          $('#alert_dark').text('Draft Deleted').fadeIn().delay(2000).fadeOut();
          this.this_draft = undefined;
          $('#edit_title').val('');
          $('#edit_content').val('');
          //$('#user_choose_cat').val('');
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
    }
     
  }
  
  waitForUser(callback) {
    var fun = (callback) => {
      if (this.props.app_state.this_user_loaded) {
        callback();
      } else {
        setTimeout(() => {
          fun(callback);
        }, 100);
      }
    }
    fun(callback);
  }
  
  this_draft = undefined;
  get_latest_draft(){      
    let this_cat = '';
    if ('category' === window.location.pathname.split('/')[1].toLowerCase())
      this_cat = window.location.pathname.split('/')[2].toLowerCase() || '';
    
    let this_user = this.props.app_state.this_user;
    if (this_user !== null 
          && typeof this_user.latest_draft !== 'undefined'
          && $('#edit_title').val().length === 0
          && $('#edit_content').val().length === 0) {
            
      $('#edit_title').val('');
      $('#edit_content').val('');
      $('#user_choose_cat').val('');
            
      let latest_draft = this_user.latest_draft;         
      //console.log('setting up draft', latest_draft['title'], latest_draft['content'])
      $('#edit_title').val(latest_draft['title']);
      $('#edit_content').val(latest_draft['content']);
      $('#user_choose_cat').val(latest_draft['category']);
      this.this_draft = latest_draft;
    }    
  }
  componentDidUpdate(prev_props, prev_state) {
    // do this first time also
    this.get_latest_draft();
    
    autosize($('textarea'));
  }
  
  componentDidMount() {
    this.waitForUser.call(this, () => {});
    if (window.location.pathname.split('/')[1].toLowerCase() === 'category') {
      let this_cat = window.location.pathname.split('/')[2].toLowerCase();
      $('#user_choose_cat').val(this_cat);
    }
    this.get_latest_draft();
    
    autosize($('textarea'));
  }
  
  
  render() {
    if (this.props.app_state.this_user_loaded 
            && this.props.app_state.this_user === null) {
      // no one logged in        
      return <div id="makepost_div">
        <p>Please login or register to start posting.</p>
        <button className="btn btn-dark" 
                id="cat_login"
                onClick={e => $('#login_modal').modal('show')}>
          Login
        </button>
        <button className="btn btn-dark" 
                id="cat_reg"
                onClick={e => $('#reg_modal').modal('show')}>
          Register
        </button>
      </div>
    }
    
    let cat_options = [<option selected value=''>Choose Category...</option>];
    for(let cid in cat_names) {      
      cat_options.push(<option value={cid}>
        {cat_names[cid]}
      </option>);
    }
    let cat_selector = <select className="custom-select" id="user_choose_cat">          
      {cat_options}
    </select>
    if (window.location.pathname.split('/')[1].toLowerCase() === 'category') {
      cat_selector = null;
    }
    
    
    return (
      <div id="makepost_div">
        <input id="edit_title" type="text" className="form-control" 
                            placeholder="Post Title" aria-label="Post Name" />
        <textarea id="edit_content" aria-label="Post Content"
                                    placeholder="Post content..."
                                    rows="2"></textarea>
        
        {cat_selector}
        <button className="btn btn-dark"
                onClick={this.publish_or_draft.bind(this, 'publish')}>Publish</button>
        <button className="btn btn-dark mid_btn"
                onClick={this.publish_or_draft.bind(this, 'update_draft')}>Save Draft</button>
        <button className="btn btn-outline-danger"
                onClick={this.do_delete.bind(this)}>Delete Draft</button>
      </div>
    );
  }
}

const cat_names = {
  'relationships': 'Relationships',
  'mentalhealth': 'Mental Health',
  'sexualorientation': 'Sexual Orientation',
  'loss': 'Loss',
  'race': 'Race',
  'suicide': 'Suicide',
  'abuse': 'Abuse',
  'addiction': 'Addiction',
  'eatingdisorders': 'Eating Disorders',
  'miscellaneous': 'Miscellaneous',
  'religion': 'Religion',
}


// WEBPACK FOOTER //
// ./src/components/MakePost.js